module.exports = __webpack_public_path__ + "img/img99.14531e0d.jpg";